import React, { useEffect, useState, useRef } from 'react'
// import { useHistory } from 'react-router-dom'
import { Col, Button, Modal, Form, Input, Card, Select } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import SearchBar from '@/components/searchbar/SearchBar'
// import SelectAll from '@/components/searchbar/SelectAll'
import AntdTable from '@/components/table/AntdTable'
// import { clearAuthentication } from '@/utils/authHelp'
import {
  getUserAdd,
  userUpdate,
  getUserList,
  getUserDelete,
  getPlantDropDownList
} from '@/services/UserManagement/userManagement'
import { getRoleList } from '@/services/RoleManagement/RoleManagement'
import { paginationInit, formatMessageNew, initValueAndLabel, uniqueFun } from '@/utils/common'
import { modalConfirm, messageModal } from '@/utils/modalUtils'
import { regEmail } from '@/utils/regUtils'
import { YN_LIST } from './types'
import { findPlantModules } from '../../services/writeOff/writeOff'
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 }
  }
}
const UserManagement = () => {
  // let commonStore = useSelector(state => state.commonStore)
  let formRef = useRef(null)
  const [initForm] = Form.useForm()
  // const history = useHistory()
  const [tableList, setTableList] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [rolesList, setRolesList] = useState([])
  const [plantList, setPlantList] = useState([])
  const [nfcPlantList, setNfcPlantList] = useState([])
  const [visibleFlag, setVisibleFlag] = useState(false)
  const [queryFlag, setQueryFlag] = useState(false)
  let saveParam = {}
  const [pagination, setPagination] = useState(paginationInit)
  let searchListInit = [
    {
      type: 'input',
      label: 'languageObj.userManagementLocale.email',
      key: 'loginEmail',
      initialValues: '',
      spans: {
        xl: 6,
        xxl: 6
      }
    },
    {
      type: 'select',
      label: 'languageObj.roleManagementLocale.roleName',
      key: 'roleName',
      initialValues: '',
      allowClear: true,
      selectList: [],
      spans: {
        xl: 6,
        xxl: 6
      }
    }
  ]
  const [searchList, setSearchList] = useState(searchListInit)
  const initDataFrom = {
    loginEmail: '',
    username: '',
    roleIdList: [],
    plantList: [],
    nfcPlantList: [],
    greyMarketAccess: 2
  }
  const [dataFrom, setDataFrom] = useState(initDataFrom)
  const tableColumns = [
    {
      title: formatMessageNew('languageObj.userManagementLocale.email'),
      dataIndex: 'loginEmail',
      width: 100,
      render: (text, record) => {
        return (
          <div onClick={() => addAndEdit(record)} className="link_name">
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessageNew('languageObj.userManagementLocale.userId'),
      dataIndex: 'username',
      width: 100,
      render: text => {
        return <div>{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.roleManagementLocale.category'),
      dataIndex: 'category',
      width: 100,
      render: text => {
        return <div>{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.userManagementLocale.role'),
      dataIndex: 'roleList',
      width: 200,
      render: text => {
        return <div>{(text.map(item => item.roleName) || []).join(',')}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.commonLocale.plant'),
      dataIndex: 'plant',
      width: 200
    },
    {
      title: formatMessageNew('languageObj.commonLocale.nfcPlant'),
      dataIndex: 'nfcPlant',
      width: 200
    }
  ]
  useEffect(() => {
    searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  useEffect(() => {
    getRoleListFun()
    getPlantListFun()
    findNfcPlantModulesFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getPlantListFun = () => {
    getPlantDropDownList().then(res => {
      let dt = res.resultData
      setPlantList(initValueAndLabel(uniqueFun(dt, 3)))
    })
  }

  const findNfcPlantModulesFun = () => {
    let param = {
      isConfig: true
    }
    findPlantModules(param).then(res => {
      let ls = res.resultData.map(item => {
        return {
          label: item,
          value: item
        }
      })
      setNfcPlantList(ls)
    })
  }

  const getRoleListFun = () => {
    getRoleList({}).then(res => {
      setRolesList(res.resultData)
      searchListInit.forEach(itemFirst => {
        if (itemFirst.key === 'roleName') {
          let uniqueRes = []
          switch (itemFirst.key) {
            case 'roleName':
              uniqueRes = res.resultData.map(item => {
                return {
                  label: item.roleName,
                  value: item.roleName
                }
              })
              break
            default:
              uniqueRes = []
              break
          }
          itemFirst.selectList = uniqueRes
        }
      })
      setSearchList([...searchListInit])
    })
  }
  const searchDataBtn = () => {
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const searchDataFun = () => {
    setSelectedRowKeys([])
    let info = {}
    info = (formRef.current && formRef.current.getValue()) || {}
    const params = {
      ...info,
      userStatus: true,
      size: pagination.pageSize,
      pageNo: pagination.currentPage
    }
    getUserList(params).then(res => {
      const dt = res.resultData
      setTableList(dt.records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }
  const searchClearDataBtn = () => {
    formRef && formRef.current.clearForm()
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  const deleteUser = () => {
    modalConfirm(
      {
        title: formatMessageNew('languageObj.commonLocale.delete'),
        content: formatMessageNew('languageObj.userManagementLocale.deleteUserTip')
      },
      () => {
        const loginEmails = selectedRowKeys.map(item => {
          return `loginEmails=${tableList[item].loginEmail}`
        })
        let params = loginEmails.join('&')
        getUserDelete(params).then(res => {
          messageModal('success', { content: formatMessageNew('languageObj.commonLocale.success') })
          if (selectedRowKeys.length === tableList.length) {
            const pag = {
              ...pagination,
              currentPage: pagination.currentPage - 1
            }
            setPagination({ ...pag })
          }
          setQueryFlag(!queryFlag)
        })
      }
    )
  }
  const addAndEdit = record => {
    setVisibleFlag(true)
    initForm.resetFields()
    if (record) {
      record.roleIdList = record.roleList.map(item => item.roleId)
      record.plantList = record.plant ? record.plant.split(',') : []
      record.nfcPlantList = record.nfcPlant ? record.nfcPlant.split(',') : []
      record.greyMarketAccess = record.greyMarketAccess || ''
      setDataFrom(record)
      initForm.setFieldsValue(record)
    } else {
      setDataFrom(initDataFrom)
      initForm.setFieldsValue(initDataFrom)
    }
  }
  // const checkOwnInfo = values => {
  //   const accountLogin = commonStore.account
  //   return accountLogin === values.username ? true : false
  // }
  const handleUserOk = () => {
    initForm
      .validateFields()
      .then(values => {
        let params = {
          ...dataFrom,
          ...values
        }
        if (dataFrom.id) {
          // 修改
          saveParam = params
          modalConfirm({ content: formatMessageNew('languageObj.userManagementLocale.changeRoleTip') }, () => {
            handleConfirmOk()
          })
        } else {
          // 新增
          saveFun(params, () => {
            messageModal('success', { content: formatMessageNew('languageObj.commonLocale.success') })
            handleUserCancel()
            setQueryFlag(!queryFlag)
          })
        }
      })
      .catch(errorInfo => {
        console.log(errorInfo)
      })
  }
  // const checkallChange = (ls, key) => {
  //   initForm.setFieldValue(key, ls)
  // }
  const handleConfirmOk = () => {
    let updateParams = {
      id: saveParam.id,
      loginEmail: saveParam.loginEmail,
      roleIdList: saveParam.roleIdList,
      plantList: saveParam.plantList,
      nfcPlantList: saveParam.nfcPlantList,
      username: saveParam.username,
      greyMarketAccess: saveParam.greyMarketAccess
    }
    userUpdate(updateParams).then(() => {
      messageModal('success', { content: formatMessageNew('languageObj.commonLocale.success') })
      handleUserCancel()
      setQueryFlag(!queryFlag)
      // if (checkOwnInfo(saveParam)) {
      //   // 是自己
      //   setTimeout(() => {
      //     clearAuthentication()
      //     history.push('/login')
      //   }, 2000)
      // } else {
      //   // 不是自己
      // }
    })
  }
  const saveFun = (params, cb) => {
    getUserAdd(params).then(res => {
      cb && cb()
    })
  }
  const handleUserCancel = () => {
    setVisibleFlag(false)
  }
  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys)
  }
  const rowSelection = {
    selectedRowKeys,
    // getCheckboxProps: record => ({
    //   disabled: record.username === commonStore.account
    // }),
    onChange: onSelectChange
  }
  const hasSelected = selectedRowKeys.length > 0
  return (
    <Card bordered={false} bodyStyle={{ padding: 4 }}>
      <div className="search-bar">
        <SearchBar ref={formRef} searchList={searchList}>
          <Col
            xs={24}
            sm={12}
            md={12}
            lg={8}
            xl={6}
            xxl={6}
            className="right_search"
            style={{ justifyContent: 'flex-end' }}
          >
            <Button icon={<SearchOutlined />} type="primary" onClick={searchDataBtn}>
              {formatMessageNew('languageObj.commonLocale.search')}
            </Button>
            <Button onClick={searchClearDataBtn}>{formatMessageNew('languageObj.commonLocale.clear')}</Button>
          </Col>
        </SearchBar>
      </div>
      <div className="content-container">
        <div className="mb15">
          <Button type="primary" onClick={() => addAndEdit()}>
            {formatMessageNew('languageObj.commonLocale.addNew')}
          </Button>
          <Button type="primary" className="ml20" disabled={!hasSelected} onClick={deleteUser}>
            {formatMessageNew('languageObj.commonLocale.delete')}
          </Button>
        </div>
        <AntdTable
          rowSelection={rowSelection}
          dataSource={tableList}
          columns={tableColumns}
          pagination={pagination}
          onChange={handleTableChange}
        />
      </div>
      <Modal
        open={visibleFlag}
        maskClosable={false}
        className="nike_modal"
        width="50%"
        title={
          dataFrom.id
            ? formatMessageNew('languageObj.commonLocale.edit')
            : formatMessageNew('languageObj.commonLocale.addNew')
        }
        onOk={handleUserOk}
        onCancel={handleUserCancel}
      >
        <Form form={initForm} {...formItemLayout}>
          <Form.Item
            label={formatMessageNew('languageObj.userManagementLocale.email')}
            name="loginEmail"
            rules={[
              {
                required: true,
                validator: (_, value) => {
                  if (value) {
                    if (regEmail.test(value)) {
                      return Promise.resolve()
                    } else {
                      return Promise.reject(
                        new Error(formatMessageNew('languageObj.userManagementLocale.checkNikeEmailFormat'))
                      )
                    }
                  } else {
                    return Promise.reject(
                      new Error(
                        formatMessageNew('languageObj.userManagementLocale.email') +
                          formatMessageNew('languageObj.commonLocale.isRequired')
                      )
                    )
                  }
                }
              }
            ]}
            initialValue={dataFrom.loginEmail}
          >
            <Input
              allowClear
              maxLength={100}
              disabled={dataFrom.id ? true : false}
              placeholder={formatMessageNew('languageObj.commonLocale.placeholderInput')}
            />
          </Form.Item>
          <Form.Item
            label={formatMessageNew('languageObj.userManagementLocale.userId')}
            name="username"
            rules={[
              {
                required: true,
                message:
                  formatMessageNew('languageObj.userManagementLocale.userId') +
                  formatMessageNew('languageObj.commonLocale.isRequired')
              }
            ]}
            initialValue={dataFrom.username}
          >
            <Input
              allowClear
              maxLength={20}
              placeholder={formatMessageNew('languageObj.commonLocale.placeholderInput')}
            />
          </Form.Item>
          <Form.Item
            label={formatMessageNew('languageObj.userManagementLocale.role')}
            name="roleIdList"
            rules={[
              {
                required: true,
                message:
                  formatMessageNew('languageObj.userManagementLocale.role') +
                  formatMessageNew('languageObj.commonLocale.isRequired')
              }
            ]}
            initialValue={dataFrom.roleIdList}
          >
            <Select
              showSearch
              allowClear
              mode="multiple"
              // 修复不出滚动条的bug
              listItemHeight={45}
              style={{ width: '100%' }}
              placeholder={formatMessageNew('languageObj.commonLocale.placeholderSelect')}
              optionFilterProp="children"
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {rolesList.map((item, idx) => {
                return (
                  <Select.Option key={idx} value={item.id}>
                    {item.roleName}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>

          <Form.Item
            label={formatMessageNew('languageObj.commonLocale.rfidPlant')}
            name="plantList"
            initialValue={dataFrom.plantList}
          >
            {/* <SelectAll
              formValues={initForm.getFieldValue()}
              allowClearFlag={true}
              showAll={true}
              initialValues={dataFrom.plantList}
              selectList={plantList}
              selectKey={'plantList'}
              mode="multiple"
              selectAllBack={e => {
                checkallChange(e, 'plantList')
              }}
            /> */}
            <Select
              showSearch
              allowClear
              mode="multiple"
              style={{ width: '100%' }}
              placeholder={formatMessageNew('languageObj.commonLocale.placeholderSelect')}
              optionFilterProp="children"
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {plantList.map((item, idx) => {
                return (
                  <Select.Option key={idx} value={item.value}>
                    {item.label}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item
            label={formatMessageNew('languageObj.commonLocale.nfcPlant')}
            name="nfcPlantList"
            initialValue={dataFrom.nfcPlantList}
          >
            <Select
              showSearch
              allowClear
              mode="multiple"
              style={{ width: '100%' }}
              placeholder={formatMessageNew('languageObj.commonLocale.placeholderSelect')}
              optionFilterProp="children"
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {nfcPlantList.map((item, idx) => {
                return (
                  <Select.Option key={idx} value={item.value}>
                    {item.label}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>

          <Form.Item
            label={formatMessageNew('languageObj.userManagementLocale.greyMarketAccess')}
            rules={[
              {
                required: true,
                message:
                  formatMessageNew('languageObj.userManagementLocale.greyMarketAccess') +
                  formatMessageNew('languageObj.commonLocale.isRequired')
              }
            ]}
            name="greyMarketAccess"
            initialValue={dataFrom.greyMarketAccess}
          >
            <Select
              showSearch
              style={{ width: '100%' }}
              placeholder={formatMessageNew('languageObj.commonLocale.placeholderSelect')}
              optionFilterProp="children"
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {YN_LIST.map((item, idx) => {
                return (
                  <Select.Option key={idx} value={item.value}>
                    {item.label}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  )
}
export default UserManagement
